import { useMemoizedContentGetter } from 'utils/contentful'
import Section from 'components/Section'
import { Typography } from '@/components/Contentful'
import { memo } from 'react'

const BasicTableModule = memo(function BasicTableModule({ config, subtitle }) {
  const { table } = config || {}
  return (
    <Section
      disableGutters={true}
      data-testid="basic-table-section"
      className="py-4  lg:py-0 "
      childContainerClassName="px-4 sm:px-8"
    >
      <div className="grid grid-cols-4 gap-x-8 gap-y-0 breakpointMd:grid-cols-6 breakpointLg:grid-cols-12 breakpointLg:gap-x-8 breakpointLg:gap-y-0 breakpointXl:grid-cols-12 breakpointXl:gap-x-8 breakpointXl:gap-y-0">
        <div className="col-span-4 breakpointMd:col-span-6 breakpointLg:col-span-12 breakpointXl:col-span-12">
          {subtitle && (
            <Typography
              content={subtitle.json || subtitle.textContent}
              variant="bodyMd"
              className="bodyMd mb-4 text-left"
              data-testid="basic-table-subtitle"
            />
          )}
          <div className="overflow-x-auto">
            <table className="w-full min-w-[690px] sm:min-w-0 border-solid border-collapse border border-border-primary">
              <tbody>
                {table &&
                  table.length > 0 &&
                  table.map((row, rowIndex) => (
                    <tr key={rowIndex} data-testid={`table-row-${rowIndex}`}>
                      {row.columns.map((col, colIndex) => {
                        const Tag = col.style === 'title' ? 'th' : 'td'
                        return (
                          <Tag
                            key={colIndex}
                            className={`py-4 px-6 text-center bodySm w-1/3 border border-border-primary border-solid ${
                              col.style === 'title' ? 'font-bold' : 'font-normal'
                            }`}
                            style={col.style === 'danger' ? { color: '#CF264E' } : undefined}
                            data-testid={`table-cell-${rowIndex}-${colIndex}`}
                          >
                            {col.text}
                          </Tag>
                        )
                      })}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Section>
  )
})

function BasicTable({ content }) {
  const { config, subtitle } = useMemoizedContentGetter(content, ['config', 'subtitle'])
  return <BasicTableModule config={config?.jsonContent || {}} subtitle={subtitle?.textContent} />
}

export { BasicTable, BasicTableModule }
export default BasicTable
